// Messaging Campaign Model
cv.MessagingCampaign = Backbone.RESTModel.extend({
  defaults : {
    title : '',
    body : ''
  },

  saveMap : {
  },

  urlRoot: function(){
    return cv.api_path + '/messaging_campaigns';
  },

  initialize: function(){
    console.log('Messaging campaign model initialized.');
  }
});
Cocktail.mixin(cv.MessagingCampaign, cv.mixins.SyncModel);

// Messaging Campaign Collection
cv.MessagingCampaigns = Backbone.Collection.extend({
  initialize: function(){
    console.log('Organization members collection initialized.');
  },

  url: function() {
    return cv.api_path + "/messaging_campaigns?" +  $.param(this.params);
  },

  model: cv.MessagingCampaign
});
Cocktail.mixin(cv.MessagingCampaigns, cv.mixins.PaginateModel);
